import { Group } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  WorkOrderItemAction,
  WorkOrderItemActionItemTypeInfo,
  WorkOrderItemActionType,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { Table } from 'antd';
import { ArrowRight } from 'react-feather';

interface Props {
  item: WorkOrderItemAction;
}

export default function WorkOrderItemActionExpandedItems({ item }: Props) {
  if (item.actionType === WorkOrderItemActionType.Change) {
    const oldItem = item.items.find((item) => item.old);
    const newItem = item.items.find((item) => !item.old);

    return (
      <Group gap={10} position="between">
        <div>
          <span style={{ fontWeight: 500, fontSize: '0.8rem' }}>Antigo</span>
          <div>{oldItem?.itemDescription}</div>
        </div>
        <ArrowRight size={18} />
        <div>
          <span style={{ fontWeight: 500, fontSize: '0.8rem' }}>Novo</span>
          <div>{newItem?.itemDescription}</div>
        </div>
      </Group>
    );
  }

  return (
    <Table
      dataSource={item.items}
      rowKey={(item) => item.workOrderItemId}
      columns={[
        { title: 'Descrição', dataIndex: 'itemDescription', width: '80%' },
        {
          title: 'Tipo',
          render: (_, item) => (
            <StatusTag
              label={
                item.type
                  ? WorkOrderItemActionItemTypeInfo[item.type].label
                  : '-'
              }
              color={
                item.type
                  ? WorkOrderItemActionItemTypeInfo[item.type].color
                  : 'default'
              }
            />
          ),
        },
      ]}
      pagination={false}
      scroll={{ x: true }}
    />
  );
}
